import { DateTime } from "luxon";
import { GeoAddressRequest } from "../geo-addresses";

export interface EditJobRequest  {
  Id: string;
  jobNumber: string;
  jobName: string;
  startTime: DateTime;
  endTime: DateTime;
  jobTemplate:string;
  vehicleType?: string;
  startAddress: string;
  endAddress: string;
  startTerminalName: string;
  endTerminalName: string;
  capacityType1?:number,
  capacityType2?: number,
  capacityType3?: number,
  startGeoAddress?: GeoAddressRequest;
  endGeoAddress?: GeoAddressRequest;
  distributionAreaId?: string;
  distributionAreaName?: string;
  connectionId : string;
  isCalculateETA? : boolean;
  startTerminalCity?: string;
  startTerminalPostalCode?: string;
  endTerminalCity?: string;
  endTerminalPostalCode?: string;
}
